import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/materials/')({
  loader: () => {
    throw redirect({
      to: `/materials/bcp-priced`,
    })
  },
})
